(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1974],{

/***/ 53784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IndexView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5951);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89231);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var IndexView = function IndexView(props) {
  var className = props.className,
      _props$isTry = props.isTry,
      isTry = _props$isTry === void 0 ? true : _props$isTry,
      _props$btnType = props.btnType,
      btnType = _props$btnType === void 0 ? 'banner' : _props$btnType,
      btnWidth = props.btnWidth;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btnGroup), !!className && className),
    children: [isTry && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      color: "green",
      className: 'btnTry',
      href: "/try",
      children: "\u7ACB\u5373\u8BD5\u7528"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      href: "/contact",
      children: "\u8054\u7CFB\u9500\u552E"
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (IndexView);

/***/ }),

/***/ 50747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ classroom; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/contact/index.tsx
var contact = __webpack_require__(53784);
// EXTERNAL MODULE: ./src/components/layout/index.tsx + 6 modules
var layout = __webpack_require__(16569);
// EXTERNAL MODULE: ./src/styles/double/classroom.module.scss
var classroom_module = __webpack_require__(17422);
var classroom_module_default = /*#__PURE__*/__webpack_require__.n(classroom_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/classroom/playerMobile/index.module.scss
var index_module = __webpack_require__(31215);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/classroom/playerMobile/index.tsx





var play_btn = '/v2/images/pc-play.png';

var PlayerMobile = function PlayerMobile(_ref) {
  var videoSrc = _ref.videoSrc,
      src = _ref.src,
      title = _ref.title;

  var _useState = (0,react.useState)(false),
      isPlay = _useState[0],
      setIsPlay = _useState[1];

  var videoRef = (0,react.useRef)(null);

  var play = function play(value) {
    setIsPlay(true);

    if (value) {
      var _videoRef$current;

      (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.play();
    } else {
      var _videoRef$current2;

      (_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.pause();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((index_module_default())["player-m"], 'for-mobile'),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).bg,
      style: {
        backgroundImage: "url(".concat(src, ")")
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: play_btn,
        alt: "",
        onClick: function onClick() {
          return play(true);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
        ref: videoRef,
        controls: true,
        style: {
          display: isPlay ? 'block' : 'none'
        },
        src: videoSrc,
        children: "\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301video"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (index_module_default()).title,
      children: title
    })]
  });
};

/* harmony default export */ var playerMobile = (PlayerMobile);
// EXTERNAL MODULE: ./src/components/classroom/introduce/index.module.scss
var introduce_index_module = __webpack_require__(95743);
var introduce_index_module_default = /*#__PURE__*/__webpack_require__.n(introduce_index_module);
// EXTERNAL MODULE: ./node_modules/antd/lib/modal/style/index.js
var style = __webpack_require__(63787);
// EXTERNAL MODULE: ./node_modules/antd/lib/modal/index.js
var modal = __webpack_require__(18397);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/player/index.module.scss
var player_index_module = __webpack_require__(81983);
var player_index_module_default = /*#__PURE__*/__webpack_require__.n(player_index_module);
;// CONCATENATED MODULE: ./src/components/player/index.tsx







var Player = function Player(props, ref) {
  var _useState = (0,react.useState)(false),
      videoVisible = _useState[0],
      setVideoVisible = _useState[1];

  var _useState2 = (0,react.useState)(''),
      mp4Url = _useState2[0],
      setMp4Url = _useState2[1];

  var videoRef = (0,react.useRef)(null);

  var playVideo = function playVideo(value) {
    if (value) {
      var _videoRef$current;

      (_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.play();
    } else {
      var _videoRef$current2;

      (_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.pause();
    }

    setVideoVisible(value);
  };

  (0,react.useImperativeHandle)(ref, function () {
    return {
      play: function play(url) {
        setMp4Url(url);
        playVideo(true);
      }
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(modal/* default */.Z, {
      title: " ",
      closeIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: (player_index_module_default()).closeIcon,
        src: "/v2/images/home/live-closer.png",
        alt: "font",
        layout: "fill"
      }),
      visible: videoVisible,
      centered: true,
      footer: null,
      className: (player_index_module_default()).videoModal,
      onCancel: function onCancel() {
        return playVideo(false);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("video", {
        ref: videoRef,
        className: (player_index_module_default()).videoPlayer,
        controls: true,
        autoPlay: true,
        src: mp4Url,
        children: "\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301video"
      })
    })
  });
};

/* harmony default export */ var player = (/*#__PURE__*/(0,react.forwardRef)(Player));
;// CONCATENATED MODULE: ./src/components/classroom/introduce/index.tsx






var playBtn = '/v2/images/pc-play.png';

var Introduce = function Introduce(props) {
  var decorate = props.decorate,
      title = props.title,
      descArr = props.descArr,
      caseImg = props.caseImg,
      className = props.className;
  var playerRef = (0,react.useRef)();

  var videoPlay = function videoPlay(url) {
    var _playerRef$current;

    (_playerRef$current = playerRef.current) === null || _playerRef$current === void 0 ? void 0 : _playerRef$current.play(url);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()((introduce_index_module_default()).banner, className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (introduce_index_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "".concat(decorate),
        className: (introduce_index_module_default()).decorate,
        alt: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (introduce_index_module_default()).title,
        children: title
      }), descArr.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: item
        }, item);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: 'video-content',
        children: caseImg.map(function (item) {
          if (item.videoSrc) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: 'video-item',
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                onClick: function onClick() {
                  return videoPlay(item.videoSrc);
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: item.src,
                  alt: ""
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: playBtn,
                  className: 'play-btn',
                  alt: ""
                })]
              })
            }, item.src);
          }

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: 'video-item',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: item.src,
              alt: ""
            })
          }, item.src);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(player, {
      ref: playerRef
    })]
  });
};

var Landing = function Landing(_ref) {
  var bg = _ref.bg,
      title = _ref.title,
      desc = _ref.desc,
      descColor = _ref.descColor;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (introduce_index_module_default()).landing,
    style: {
      backgroundImage: "url(".concat(bg, ")")
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (introduce_index_module_default()).title,
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (introduce_index_module_default()).desc,
      style: {
        color: descColor ? descColor : '#fff'
      },
      dangerouslySetInnerHTML: {
        __html: desc.replace(/\n/g, '<br/>')
      }
    })]
  });
};
var IntroduceMobile = function IntroduceMobile(_ref2) {
  var list = _ref2.list;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (introduce_index_module_default()).introduce,
    children: list.map(function (item) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (introduce_index_module_default()).item,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: item.icon,
          alt: "",
          className: (introduce_index_module_default())["item-icon"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (introduce_index_module_default())["item-title"],
          children: item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (introduce_index_module_default())["item-desc"],
          dangerouslySetInnerHTML: {
            __html: item.desc.replace(/\n/g, '<br/>')
          }
        })]
      }, item.title);
    })
  });
};
/* harmony default export */ var introduce = (Introduce);
;// CONCATENATED MODULE: ./src/constants/classroom.ts
var IMG_PATH_NEW = 'https://testdevcdn.xylink.com/h5/sdk_doc/static/website/double-classroom/';
var scheme = [{
  title: '全球部署',
  desc: '通过云计算连接万间课堂\n栩栩如生',
  descM: '通过云计算\n连接万间课堂\n栩栩如生',
  icon: "".concat(IMG_PATH_NEW, "pc/c03bbabb5ba94f8a07e742d24da306ec6982464acf4dd8c69726018db8e41f13.png")
}, {
  title: '云端课堂',
  desc: '云端课堂再现教师真人大小\n高保真图像及声音',
  descM: '云端课堂再现\n教师真人大小\n高保真图像及声音',
  icon: "".concat(IMG_PATH_NEW, "pc/c314d967f47adbc5a236467e67052147a7e0a17e10fbc9bb61877f795b5e3132.png")
}, {
  title: '按需定制',
  desc: '可根据实际应用场景需求\n量身定制双师课堂解决方案',
  descM: '可根据实际应用场景需求\n量身定制双师课堂\n解决方案',
  icon: "".concat(IMG_PATH_NEW, "pc/8921569391e9b307a80931a1058fa4a9758cc4f927d46d12758922c6cda94bf7.png")
}, {
  title: '拓展兼容',
  desc: '与双师课堂专业硬件设备全兼容\n打造一站式授课/听课完美体验',
  descM: '专业硬件设备全兼容\n打造一站式授课\n听课完美体验',
  icon: "".concat(IMG_PATH_NEW, "pc/d21b28fdb883cddd186dee83bcc68013bb6fca6f49a63eac75279a21046dc29c.png")
}];
var classroom1 = {
  decorate: "".concat(IMG_PATH_NEW, "pc/dcde7ee352625aee93c126eb91891c2df0fca620e8027eccdb8c10a9bded240a.png"),
  title: '这是一间简单易用的双师课堂',
  descArr: ['基于互联网环境下大规模部署的高清课堂', '智能化授课端以及听课端设备使用简单', '万间教室集中管理，复制推广性价比极高'],
  caseImg: [{
    src: "".concat(IMG_PATH_NEW, "pc/e3a3cbb5418a16533a2780876771e2a3e90511c81787f7a07d285819331deebd.jpg"),
    videoSrc: 'http://devcdn.xylink.com/website/video/double__class-01.mp4'
  }, {
    src: "".concat(IMG_PATH_NEW, "pc/3a408be3750afec467f835edabf45cfbe97012446f40fd298385fd05310314a9.jpg"),
    videoSrc: 'http://devcdn.xylink.com/website/video/double__class-02.mp4'
  }]
};
var classroom2 = {
  decorate: "".concat(IMG_PATH_NEW, "pc/40a8568eddc0f5ac355236dcc9f4e4946495383117158c7d03016f08e3028340.png"),
  title: '这是一间百变大咖的双师课堂',
  descArr: ['设备扩展：电子白板、点阵笔、答题器、手写笔、无线传屏', '功能扩展：课前预约、课堂互动、课中管理、课后点播、考评', '平台扩展：教学系统SDK集成，可定制开发、兼容教学平台'],
  caseImg: [{
    src: "".concat(IMG_PATH_NEW, "pc/a9d57167ab1d28dde8322a951c8941aab2ebc2d0203e39fc04d8504cd9607de4.jpg")
  }, {
    src: "".concat(IMG_PATH_NEW, "pc/c644e85c6fa6add59ddf3416ba8e30c57623d98479f3aac8c8a3fbcb715f58fb.jpg")
  }, {
    src: "".concat(IMG_PATH_NEW, "pc/23b6c9d10f92e048529af9a56f519709afc260d41cffa4d213586a435bb7b46c.jpg")
  }]
};
var classroom3 = {
  decorate: "".concat(IMG_PATH_NEW, "pc/ab9dc55b00426c39432a6ce26888f4a59c5434e27a7c7b9f43cf992cb05cb80c.png"),
  title: '双师课堂听课端',
  descArr: ['十二倍光学变焦，无死角捕捉学生听课效果', '八米远距离拾音，保证教室任意角落声音清晰', '支持定制二次开发，集成多种教学设备功能模块'],
  caseImg: [{
    src: "".concat(IMG_PATH_NEW, "pc/e6fcbf9af087f3dd51d0852b00e135d3d9dedced30600673d2c2945d781571bb.jpg")
  }, {
    src: "".concat(IMG_PATH_NEW, "pc/c493176041e25bddb828c479ecefe7b0c1b8a0b74299277ed6bd6230ec40e2cc.jpg")
  }]
};
var introduce1 = [{
  icon: "".concat(IMG_PATH_NEW, "mobile/58101e6c94814198270604cf62174c18cd79cf0a1da7151ed77f90734d21456a.jpg"),
  title: '这是一间简单易用的双师课堂',
  desc: '基于互联网环境下大规模部署的高清课堂\n智能化授课端以及听课端设备使用简单\n万间教室集中管理，复制推广性价比极高'
}, {
  icon: "".concat(IMG_PATH_NEW, "mobile/370a05a5a2c652a9b63dba87ddd4f5c032c907525a05a75d3e4df80902600d68.jpg"),
  title: '这是一间栩栩如生的双师课堂',
  desc: '核心音视频算法，保障互联网丢包环境下顺利上课\n自动负载均衡，异地多活，保证双师课堂不中断\n延时低至40ms，1080P保证实时高清流畅课堂效果'
}, {
  icon: "".concat(IMG_PATH_NEW, "mobile/b4a0ea547a05f2318119c8261c2757cf1eae1e34e52238bc092877f63e67cd6b.jpg"),
  title: '这是一间百变大咖的双师课堂',
  desc: '设备扩展：电子白板、点阵笔、答题器、手写笔\n功能扩展：课前预约、课中互动管理、课后点播\n平台扩展：SDK集成，兼容教学系统二次开发'
}];
var introduce2 = [{
  icon: "".concat(IMG_PATH_NEW, "mobile/b541b3331a9ac0149a32d84f52c85ff55be322261e2ea515b1ae000fe0477ca7.jpg"),
  title: '双师课堂授课端',
  desc: '20倍光学变焦，十六分屏显示，完美呈现教学细节\n专业云视频硬件终端，还原真实课堂互动效果\n专业的音视频终端方案，搭配双师课堂专业设备'
}, {
  icon: "".concat(IMG_PATH_NEW, "mobile/ba14b461f4c6f715e755018dcba1d93143166688945ffef70313a0ab3e9b3243.jpg"),
  title: '双师课堂听课端',
  desc: '十二倍光学变焦，无死角捕捉学生听课效果\n八米远距离拾音，保证教室任意角落声音清晰\n支持定制二次开发，集成多种教学设备功能模块'
}];
var mobileVideo = [{
  title: '双师课堂授课教室',
  videoSrc: 'http://devcdn.xylink.com/website/video/double__class-01.mp4',
  src: "".concat(IMG_PATH_NEW, "mobile/3d3c480cf959bbf70008ddb20f481a2bf961037c90d38a40f6192c2def53ad2a.jpg")
}, {
  title: '双师课堂听课教室',
  videoSrc: 'http://devcdn.xylink.com/website/video/double__class-02.mp4',
  src: "".concat(IMG_PATH_NEW, "mobile/cdc3190621f05864c714c9e6cdf1f179a37a5b53a8b0fc064861f11c8096d7d5.jpg")
}];
;// CONCATENATED MODULE: ./src/pages/double/classroom.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var Index = function Index() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "\u5C0F\u9C7C\u6613\u8FDE-\u53CC\u5E08\u8BFE\u5802"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (classroom_module_default()).banner1,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\u4E91\u7AEF\u53CC\u5E08\uFF0C\u4E00\u8BFE\u53C8\u4E00\u8BFE"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Hello\uFF0C\u65B0\u6559\u5BA4"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(contact/* default */.Z, {
        className: (classroom_module_default()).contact
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (classroom_module_default()).banner2,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (classroom_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (classroom_module_default()).quot,
          children: "\u4E92\u8054\u7F51\u6280\u672F\u7684\u53D1\u5C55\u63A8\u8FDB\u6559\u80B2\u4FE1\u606F\u5316\u53D8\u9769\uFF0C\u4EBF\u4E07\u5B69\u5B50\u540C\u5728\u84DD\u5929\u4E0B\uFF0C\u5171\u4EAB\u4F18\u8D28\u6559\u80B2\u3002"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (classroom_module_default()).from,
          children: "\u2014\u2014\u4E60\u8FD1\u5E73"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderPC, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RenderMobile, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Landing, {
      bg: "".concat(IMG_PATH_NEW, "mobile/42bdec7c02595f25f3d289e30463e3f7d657d5b34fd5d10c30b80876b0b6b078.jpg"),
      title: "\u4E91\u7AEF\u670D\u52A1",
      desc: '云端统一维护、监管、升级，保障教学效果\n本地化服务，全球化业务支持，高效保障\n金融级安全保障，云服务稳定运营超过30个月',
      descColor: '#c9d2de'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(contact/* default */.Z, {
      className: (classroom_module_default())["footer-contact"]
    })]
  });
};

var RenderPC = function RenderPC() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'for-pc',
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(introduce, _objectSpread({}, classroom1)), /*#__PURE__*/(0,jsx_runtime.jsx)(Landing, {
      bg: "".concat(IMG_PATH_NEW, "pc/02077b889957f17aba0d14e6c3ba4633a4e2b59e05c926654cb12cdb9712804c.jpg"),
      title: "\u8FD9\u662F\u4E00\u95F4\u6829\u6829\u5982\u751F\u7684\u53CC\u5E08\u8BFE\u5802",
      desc: '核心音视频算法，保障授／听课双端互联网丢包环境下顺利上课\n自动负载均衡，异地多活，互为备份，保证云端双师课堂不中断\n延时低至40ms，1080P处理能力，保证实时高清流畅课堂效果'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(introduce, _objectSpread({}, Object.assign(_objectSpread(_objectSpread({}, classroom2), {}, {
      className: (classroom_module_default()).banner5
    })))), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (classroom_module_default()).banner6,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\u5C0F\u9C7C\u6613\u8FDE\u53CC\u5E08\u8BFE\u5802\u89E3\u51B3\u65B9\u6848"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (classroom_module_default()).content,
        children: scheme.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (classroom_module_default()).item,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              className: (classroom_module_default()).icon,
              src: item.icon,
              alt: ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (classroom_module_default()).title,
              children: item.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (classroom_module_default()).desc,
              dangerouslySetInnerHTML: {
                __html: item.desc.replace(/\n/, '<br/>')
              }
            })]
          }, item.title);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (classroom_module_default()).terminal,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (classroom_module_default()).me92,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(IMG_PATH_NEW, "pc/0398067d9f97972fbe47f9ff383750b7c768fa051fc7d8019a8c6be579b64e86.jpg"),
              alt: ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (classroom_module_default()).title,
              children: "\u5927\u578B\u6559\u5BA4\u6388\u8BFE\u7EC8\u7AEFME92"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (classroom_module_default()).cloud,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(IMG_PATH_NEW, "pc/42ccdb772ceec7cbc567a7059b9d7ce80830757d0f5f73f335a1d761e6e6c707.png"),
            alt: ""
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (classroom_module_default()).me42,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(IMG_PATH_NEW, "pc/7c23a20a32bceea953262df512cb670c6994df4da78693a8833b774c659dc755.jpg"),
              alt: ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (classroom_module_default()).title,
              children: "\u9AD8\u6027\u80FD\u4E2D\u578B\u6559\u5BA4\u6388\u8BFE\u7EC8\u7AEFME42"
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Landing, {
      bg: "".concat(IMG_PATH_NEW, "pc/f9c5d010e4d513156de2309bccdfb98627c3d1092c2d8966705c26979d906a85.jpg"),
      title: "\u53CC\u5E08\u8BFE\u5802\u6388\u8BFE\u7AEF",
      desc: '20倍光学变焦摄像机，十六分屏显示听课教室，完美呈现教学细节\n专业云视频硬件终端，部署简单，高度集成，还原真实课堂互动效果\n专业的音视频终端方案，搭配双师课堂专业设备，逼真立现'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(introduce, _objectSpread({}, Object.assign(_objectSpread(_objectSpread({}, classroom3), {}, {
      className: (classroom_module_default()).banner8
    }))))]
  });
};

var RenderMobile = function RenderMobile() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: 'for-mobile',
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (classroom_module_default()).video,
      children: mobileVideo.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(playerMobile, _objectSpread({}, item), item.title);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IntroduceMobile, {
      list: introduce1
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (classroom_module_default())["scheme-m"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (classroom_module_default()).title,
        children: "\u5C0F\u9C7C\u6613\u8FDE\u53CC\u5E08\u8BFE\u5802\u89E3\u51B3\u65B9\u6848"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (classroom_module_default()).content,
        children: scheme.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (classroom_module_default()).item,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: item.icon,
              className: (classroom_module_default())["item-icon"],
              alt: ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (classroom_module_default())["item-title"],
              children: item.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (classroom_module_default())["item-desc"],
              dangerouslySetInnerHTML: {
                __html: item.descM.replace(/\n/g, '<br/>')
              }
            })]
          }, item.title);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (classroom_module_default()).terminal,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(IMG_PATH_NEW, "mobile/4f2c8619a871aa43ea7702f8139675fefaf07e7708cbd6ad5e8e6c10c85f149c.jpg"),
            alt: ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (classroom_module_default()).title,
            children: "\u5927\u578B\u6559\u5BA4\u6388\u8BFE\u7EC8\u7AEFME92"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(IMG_PATH_NEW, "mobile/2ef6b0a3a16655a0ad3c01007ab8be1b63dcef61ae8fa9c9e32d44d77d2d3ee4.png"),
          alt: ""
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(IMG_PATH_NEW, "mobile/ff09ee2f30148597cd559a04a02ce9ed9971a9ffb7cf0aaf32f06fdf9452633f.jpg"),
            alt: ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (classroom_module_default()).title,
            children: "\u542C\u8BFE\u6559\u5BA4\u5168\u80FD\u7EC8\u7AEFME42"
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(IntroduceMobile, {
      list: introduce2
    })]
  });
};

/* harmony default export */ var classroom = (Index);

/***/ }),

/***/ 23119:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/double/classroom",
      function () {
        return __webpack_require__(50747);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95743:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"introduce_border__px__1BI_f","border__px-before":"introduce_border__px-before__pvLjy","border__px-before1":"introduce_border__px-before1__MUJyz","border-children1":"introduce_border-children1__jwSSU","border-children2":"introduce_border-children2__XSR2C","for-mobile":"introduce_for-mobile__wDKTy","for-pc":"introduce_for-pc__MsA0v","banner":"introduce_banner___1LMv","content":"introduce_content__c6s_5","decorate":"introduce_decorate__UuW6U","title":"introduce_title__iA2OE","landing":"introduce_landing__XQPBq","desc":"introduce_desc__CjIzQ","introduce":"introduce_introduce__dR1EP","item":"introduce_item__V7qtA","item-icon":"introduce_item-icon__YspXm","item-title":"introduce_item-title__q8HYm","item-desc":"introduce_item-desc__1JgGH"};

/***/ }),

/***/ 31215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"playerMobile_border__px__Jm59S","border__px-before":"playerMobile_border__px-before__6IKr7","border__px-before1":"playerMobile_border__px-before1__blO1C","border-children1":"playerMobile_border-children1__7cxd0","border-children2":"playerMobile_border-children2__B81Ve","for-mobile":"playerMobile_for-mobile__nk9Zo","for-pc":"playerMobile_for-pc__5L7aK","player-m":"playerMobile_player-m__Pydga","bg":"playerMobile_bg__DFRGd","title":"playerMobile_title__tY7N2"};

/***/ }),

/***/ 5951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"contact_border__px__DM3ZN","border__px-before":"contact_border__px-before__F0Vlr","border__px-before1":"contact_border__px-before1__wOrFT","border-children1":"contact_border-children1__bFQeI","border-children2":"contact_border-children2__8WMsP","for-mobile":"contact_for-mobile__SdQT9","for-pc":"contact_for-pc__7iuGe","btnGroup":"contact_btnGroup__Glj3p"};

/***/ }),

/***/ 81983:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"videoModal":"player_videoModal__8Ul4n","videoPlayer":"player_videoPlayer__sEbBF","closeIcon":"player_closeIcon__6wqBs"};

/***/ }),

/***/ 17422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"classroom_border__px__YLAg0","border__px-before":"classroom_border__px-before__oAtWd","border__px-before1":"classroom_border__px-before1__O6L_w","border-children1":"classroom_border-children1__0xBBz","border-children2":"classroom_border-children2__gpJd8","for-mobile":"classroom_for-mobile__tdOMH","for-pc":"classroom_for-pc___M4cQ","banner2":"classroom_banner2___W4I2","content":"classroom_content__8cvT_","banner1":"classroom_banner1__h0VLE","contact":"classroom_contact__2_UKB","quot":"classroom_quot__2JIkV","from":"classroom_from__1gIuu","banner4":"classroom_banner4__qf_pH","title":"classroom_title__BLWMT","desc":"classroom_desc__jAWKL","banner5":"classroom_banner5__FwCrw","banner6":"classroom_banner6__h7i8q","item":"classroom_item__KAjvx","icon":"classroom_icon__6JCNI","terminal":"classroom_terminal__PqP8V","cloud":"classroom_cloud___0jJh","banner8":"classroom_banner8__gBmS2","banner9":"classroom_banner9__pMpri","scheme-m":"classroom_scheme-m__Vf7Eh","item-icon":"classroom_item-icon__QByN4","item-title":"classroom_item-title__U4Nbw","item-desc":"classroom_item-desc__KDUUD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(23119); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);